<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="'Back'" (addEvent)="backToEnquiries()"
        [secondaryAction]="canEditEnquiry() ? 'Edit Enquiry' : ''" (secondaryEvent)="editEnquiry()"></app-breadcrumb>
    <div class="container-fluid">
        <!-- Comments Table Section -->
        <div class="row" *ngIf="checkViewCommentPermission">
            <div class="col-xl-12">
                <div class="card">
                    <div class="card-header border-0 d-flex justify-content-between align-items-center">
                        <h4 class="card-title">Follow Up History</h4>
                        <button *ngIf="checkAddCommentPermission" class="btn btn-primary btn-sm" (click)="openCommentDrawer()">
                            <i class="fa fa-plus me-2"></i>Add Comment
                        </button>
                    </div>
                    <div class="card-body pt-0">
                        <div class="table-responsive">
                            <table class="table table-responsive-md">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Added By</th>
                                        <th>Comment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let comment of comments">
                                        <td>{{ comment.created_at | date:'dd-MM-yyyy' }}</td>
                                        <td>{{ comment.created_by }}</td>
                                        <td [innerHTML]="comment.comment"></td>
                                    </tr>
                                    <tr *ngIf="comments.length === 0">
                                        <td colspan="3" class="text-center">No comments available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Enquiry Details Section -->
        <div class="row" *ngIf="enquiryDetails">
            <div class="col-xl-12">
                <div class="card">
                    <div class="card-header border-0">
                        <h4 class="card-title">Enquiry Details</h4>
                    </div>
                    <div class="card-body pt-0">
                        <div class="row">
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Platform</h6>
                                <p class="property-notes">{{ enquiryDetails.platform || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Platform Property ID</h6>
                                <p class="property-notes">{{ enquiryDetails.platform_property_id || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Property Type</h6>
                                <p class="property-notes">{{ enquiryDetails.property_type || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Name</h6>
                                <p class="property-notes">{{ enquiryDetails.name || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Email</h6>
                                <p class="property-notes">{{ enquiryDetails.email || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Phone</h6>
                                <p class="property-notes">{{ enquiryDetails.phone || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Property</h6>
                                <p class="property-notes">
                                    <span *ngIf="enquiryDetails.property?.id" class="text-primary c-pointer" [routerLink]="['/admin/properties/property-view', enquiryDetails.property.id, 8]">
                                        {{ enquiryDetails.property?.name }}
                                    </span>
                                    <span *ngIf="!enquiryDetails.property?.id">-</span>
                                </p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Locality</h6>
                                <p class="property-notes">{{ enquiryDetails.locality || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">City</h6>
                                <p class="property-notes">{{ enquiryDetails.city || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">State</h6>
                                <p class="property-notes">{{ enquiryDetails.state || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Amount</h6>
                                <p class="property-notes">{{ enquiryDetails.amount || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Living Room</h6>
                                <p class="property-notes">{{ enquiryDetails.living_room || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Bed Rooms</h6>
                                <p class="property-notes">{{ enquiryDetails.bath_room || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Looking For</h6>
                                <p class="property-notes">{{ enquiryDetails.looking_for || '-' }}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Status</h6>
                                <p class="property-notes">
                                    <span *ngIf="enquiryDetails.status" class="badge"
                                          [class.badge-success]="enquiryDetails.status === 'CONVERTED'"
                                          [class.badge-primary]="enquiryDetails.status === 'HOT'"
                                          [class.badge-warning]="enquiryDetails.status === 'WARM'"
                                          [class.badge-light]="enquiryDetails.status === 'COLD'"
                                          [class.badge-secondary]="enquiryDetails.status === 'REJECT'">
                                        {{ enquiryDetails.status }}
                                    </span>
                                    <span *ngIf="!enquiryDetails.status">-</span>
                                </p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <h6 class="card-title">Follow Up Date</h6>
                                <p class="property-notes">{{ enquiryDetails.follow_up_date ? (enquiryDetails.follow_up_date | date:'dd-MM-yyyy') : '-' }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<!-- Add Comment Drawer -->
<div #addCommentDrawer class="offcanvas offcanvas-end customeoff {{ drawerOpen ? 'show':''}}" tabindex="-1" id="addCommentDrawer" data-bs-backdrop="static">
    <div class="offcanvas-header">
        <h5 class="modal-title" id="#gridSystemModal">Add Comment</h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" (click)="closeCommentDrawer()">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
    <div class="offcanvas-body">
        <div class="container-fluid">
            <form [formGroup]="commentForm" (ngSubmit)="saveComment()" autocomplete="off">
                <div class="row">
                    <div class="col-xl-12 mb-3">
                        <label for="comment" class="form-label">Comment<span class="text-danger">*</span></label>
                        <ckeditor [editor]="Editor" formControlName="comment"></ckeditor>
                        <div *ngIf="commentForm?.get('comment')?.invalid && commentForm?.get('comment')?.touched" class="required">
                            Comment is required
                        </div>
                    </div>
                </div>
                <div>
                    <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="commentForm.invalid || loadingService.isLoading()">Save</button>
                    <button class="btn btn-danger light me-1" type="button" (click)="closeCommentDrawer()">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>
@if(drawerOpen){
    <div class="offcanvas-backdrop fade show" (click)="closeCommentDrawer()"></div>
}
